import classes from './StaticListItem.module.css'
import StaticTextContent from "./StaticTextContent";

const StaticListItem = ({
  id,
  name,
  apy,
  effective_at,
  member,
  min_to_open,
  balanceToAvoidFees
}) => {

  return (
    <div className={classes.container} key={id}>
      <div className={classes.mainContent}>
        <div className={classes.leftContainer}>
          <div className={classes.logoContainer}>
            <p>{name}</p>
          </div>
        </div>
        <div className={classes.middleContainer}>
          <StaticTextContent apy={apy} effective_at={effective_at} min_to_open={min_to_open} balanceToAvoidFees={balanceToAvoidFees}/>
        </div>
      </div>
      <div className={classes.infoWrapper}>
        {member && <p>Member {member} </p>}
      </div>
    </div>
  );
};

export default StaticListItem;